import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
}

const Card: React.FC<CardProps> = ({ children, className = '' }) => {
  return (
    <div className={`bg-white/60 border border-white/50 rounded-xl p-6 shadow-lg backdrop-blur-xl ${className}`}>
      {children}
    </div>
  );
};

export default Card;